module.exports = __webpack_public_path__ + "static/img/hangyefenxi1.1ec35c87.png";